import { Announcement } from "@/src/types/types";

import { WritableAtom } from "jotai";
import { RESET, atomWithStorage, createJSONStorage } from "jotai/utils";

const sessionStorage = createJSONStorage<Announcement[]>(() =>
  typeof globalThis.window === "undefined"
    ? (undefined as never)
    : globalThis.window.sessionStorage
);

type ResetAction<T> = T | typeof RESET | ((prev: T) => T | typeof RESET);

export const announcementsAtom: WritableAtom<
  Announcement[],
  [ResetAction<Announcement[]>],
  void
> = atomWithStorage<Announcement[]>("announcements", [], sessionStorage, {
  getOnInit: true
});
